const CHECK_EVERY_MS = 5 * 60 * 1000;
const TAKEOVER_WAIT_MS = 45 * 1000;
const FORCED_KEY = "eclipse_forced_release";

export async function deployedBuild(): Promise<string | null> {
  try {
    const response = await fetch("/version.json", { cache: "no-store" });
    if (!response.ok) return null;
    const { build } = (await response.json()) as { build?: unknown };
    return typeof build === "string" ? build : null;
  } catch {
    return null;
  }
}

const readForced = () => {
  try {
    return sessionStorage.getItem(FORCED_KEY);
  } catch {
    return null;
  }
};

const writeForced = (build: string) => {
  try {
    sessionStorage.setItem(FORCED_KEY, build);
  } catch {
    // Note: without session storage the reload below could repeat, so it is skipped instead.
    return false;
  }
  return true;
};

const currentRegistration = async () => {
  try {
    return await navigator.serviceWorker?.getRegistration();
  } catch {
    return undefined;
  }
};

async function switchToRelease(deployed: string, reload: () => void) {
  if (readForced() === deployed || !writeForced(deployed)) return;

  const registrations = await navigator.serviceWorker?.getRegistrations().catch(() => []) ?? [];
  await Promise.all(registrations.map(registration => registration.unregister()));
  reload();
}

// Note: the service worker normally swaps a release in by itself; this covers a tab left open across a release and
// a worker that never takes over, which would otherwise keep serving the old app until someone hard-refreshes.
export function keepCurrent(currentBuild: string, reload: () => void = () => window.location.reload()) {
  const check = async (atStart: boolean) => {
    if (!navigator.onLine) return;

    const deployed = await deployedBuild();
    if (!deployed || deployed === currentBuild) return;

    await (await currentRegistration())?.update().catch(() => undefined);
    if (atStart) setTimeout(() => void switchToRelease(deployed, reload), TAKEOVER_WAIT_MS);
  };

  void check(true);
  setInterval(() => void check(false), CHECK_EVERY_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void check(false);
  });
}
